import { Navigate, Outlet } from 'react-router'
import { RouteHeader } from '../constant/routeAndHeader';
import FullLayout from '../layouts/full/FullLayout';
import Label from '../components/xaoasoft/label';
import Customizemenu from '../layouts/full/customizemenu/customizemenu';

// const authData = RouteHeader().router.auth;
// const SinglePage = RouteHeader().router.SinglePage;
// const PrivateRoute = RouteHeader().router.Menu;

const func = () =>{
  const data = RouteHeader().router
  console.log(data)
  const getdata = RouteHeader().router
  return getdata
}
const routesData = func();   // ← FIX: CALL ONLY ONCE\\


export const Routering = [
    {
        path:'/',
        elemenet: <><Outlet /><Label /></>,
        children:[
            ...routesData.SinglePage 
        ]
    }, 
    {
        path: '/Private/',
        element: <div id='fullLayout'><FullLayout /></div>,
        children:[
            ...routesData.Menu
        ]
    }
];